/**
 * Осетровые — 11 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const ОСЕТРОВЫЕ = [
    // ── Наши воды ──
    {
        id: 'sterlet',
        семейство: 'осетровые',
        latin: 'Acipenser ruthenus',
        повадка: 'осетровый',
        minKg: 0.3,
        maxKg: 8,
        typicalKg: 1.2,
        typicalLengthM: 0.5,
        depthM: 6,
        depthBandM: 3,
        сложение: 'округлое',
        пасть: 'хрящевая',
        редкость: 'очень_редкая',
        когда: 'ночная',
        вода: { мин: 5, опт: 18, макс: 26 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'перекат', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'ручейник', вес: 0.8 },
            { чем: 'мотыль', вес: 0.8 },
            { чем: 'опарыш', вес: 0.6 },
            { чем: 'рачок', вес: 0.6 },
            { чем: 'пеллетс', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'russian_sturgeon',
        семейство: 'осетровые',
        latin: 'Acipenser gueldenstaedtii',
        повадка: 'осетровый',
        minKg: 2,
        maxKg: 60,
        typicalKg: 10,
        typicalLengthM: 1.1,
        depthM: 8,
        depthBandM: 4,
        сложение: 'округлое',
        пасть: 'хрящевая',
        редкость: 'очень_редкая',
        когда: 'ночная',
        вода: { мин: 6, опт: 18, макс: 26 },
        течение: 'сильное',
        держится: ['яма', 'твёрдое_дно', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'ракушка', вес: 0.8 },
            { чем: 'рачок', вес: 0.8 },
            { чем: 'пеллетс', вес: 0.6 },
            { чем: 'резка', вес: 0.6 },
        ],
        краснокнижная: true,
    },
    {
        id: 'siberian_sturgeon',
        семейство: 'осетровые',
        latin: 'Acipenser baerii',
        повадка: 'осетровый',
        minKg: 1.5,
        maxKg: 50,
        typicalKg: 8,
        typicalLengthM: 1,
        depthM: 8,
        depthBandM: 4,
        сложение: 'округлое',
        пасть: 'хрящевая',
        редкость: 'очень_редкая',
        когда: 'ночная',
        вода: { мин: 1, опт: 16, макс: 24 },
        течение: 'слабое',
        держится: ['яма', 'ил', 'твёрдое_дно'],
        стая: 'малая_стая',
        нерест: { с: 6, по: 7 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'пеллетс', вес: 0.8 },
            { чем: 'рачок', вес: 0.8 },
            { чем: 'ракушка', вес: 0.6 },
            { чем: 'мотыль', вес: 0.6 },
        ],
        краснокнижная: true,
    },
    {
        id: 'stellate_sturgeon',
        семейство: 'осетровые',
        latin: 'Acipenser stellatus',
        повадка: 'осетровый',
        minKg: 2,
        maxKg: 40,
        typicalKg: 7,
        typicalLengthM: 1,
        depthM: 7,
        depthBandM: 3,
        сложение: 'округлое',
        пасть: 'хрящевая',
        редкость: 'очень_редкая',
        когда: 'ночная',
        вода: { мин: 8, опт: 20, макс: 28 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'бровка', 'яма'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'рачок', вес: 0.8 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'ракушка', вес: 0.8 },
            { чем: 'пеллетс', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'beluga',
        семейство: 'осетровые',
        latin: 'Huso huso',
        повадка: 'осетровый',
        minKg: 10,
        maxKg: 250,
        typicalKg: 40,
        typicalLengthM: 2,
        depthM: 10,
        depthBandM: 5,
        сложение: 'округлое',
        пасть: 'хрящевая',
        редкость: 'единичная',
        когда: 'круглосуточная',
        вода: { мин: 4, опт: 16, макс: 24 },
        течение: 'любое',
        держится: ['яма', 'открытая_вода', 'бровка'],
        стая: 'одиночка',
        нерест: { с: 4, по: 5 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'червь', вес: 0.4 },
            { чем: 'мясо', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'ship_sturgeon',
        семейство: 'осетровые',
        latin: 'Acipenser nudiventris',
        повадка: 'осетровый',
        minKg: 2,
        maxKg: 45,
        typicalKg: 8,
        typicalLengthM: 1.05,
        depthM: 8,
        depthBandM: 4,
        сложение: 'округлое',
        пасть: 'хрящевая',
        редкость: 'единичная',
        когда: 'ночная',
        вода: { мин: 6, опт: 18, макс: 26 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'бровка', 'яма'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'ракушка', вес: 0.8 },
            { чем: 'рачок', вес: 0.6 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'пеллетс', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'kaluga',
        семейство: 'осетровые',
        latin: 'Huso dauricus',
        повадка: 'осетровый',
        minKg: 10,
        maxKg: 200,
        typicalKg: 35,
        typicalLengthM: 1.9,
        depthM: 9,
        depthBandM: 5,
        сложение: 'округлое',
        пасть: 'хрящевая',
        редкость: 'единичная',
        когда: 'круглосуточная',
        вода: { мин: 2, опт: 16, макс: 23 },
        течение: 'сильное',
        держится: ['яма', 'бровка', 'открытая_вода'],
        стая: 'одиночка',
        нерест: { с: 5, по: 7 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'червь', вес: 0.4 },
            { чем: 'мясо', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    // ── Наши воды ──
    {
        id: 'paddlefish',
        семейство: 'осетровые',
        latin: 'Polyodon spathula',
        повадка: 'осетровый',
        minKg: 2,
        maxKg: 40,
        typicalKg: 8,
        typicalLengthM: 1.1,
        depthM: 5,
        depthBandM: 3,
        сложение: 'округлое',
        пасть: 'хрящевая',
        редкость: 'нечастая',
        когда: 'круглосуточная',
        вода: { мин: 8, опт: 20, макс: 28 },
        течение: 'слабое',
        держится: ['открытая_вода', 'яма', 'бровка'],
        стая: 'малая_стая',
        нерест: { с: 4, по: 5 },
        чем: [],
    },
    // ── Восточная Азия ──
    {
        id: 'amur_sturgeon',
        семейство: 'осетровые',
        latin: 'Acipenser schrenckii',
        повадка: 'осетровый',
        minKg: 1,
        maxKg: 25,
        typicalKg: 3,
        typicalLengthM: 1,
        depthM: 6,
        depthBandM: 4,
        сложение: 'округлое',
        пасть: 'хрящевая',
        редкость: 'очень_редкая',
        когда: 'ночная',
        вода: { мин: 2, опт: 16, макс: 23 },
        течение: 'сильное',
        держится: ['твёрдое_дно', 'бровка', 'яма'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'пеллетс', вес: 0.8 },
            { чем: 'рачок', вес: 0.6 },
            { чем: 'мотыль', вес: 0.6 },
            { чем: 'ракушка', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    // ── Северная Америка ──
    {
        id: 'lake_sturgeon',
        семейство: 'осетровые',
        latin: 'Acipenser fulvescens',
        повадка: 'осетровый',
        minKg: 3,
        maxKg: 50,
        typicalKg: 12,
        typicalLengthM: 1.3,
        depthM: 7,
        depthBandM: 4,
        сложение: 'округлое',
        пасть: 'хрящевая',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 4, опт: 17, макс: 24 },
        течение: 'слабое',
        держится: ['ил', 'твёрдое_дно', 'яма'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'червь', вес: 1 },
            { чем: 'рачок', вес: 0.8 },
            { чем: 'ракушка', вес: 0.6 },
            { чем: 'резка', вес: 0.4 },
        ],
        краснокнижная: true,
    },
    {
        id: 'white_sturgeon',
        семейство: 'осетровые',
        latin: 'Acipenser transmontanus',
        повадка: 'осетровый',
        minKg: 8,
        maxKg: 130,
        typicalKg: 30,
        typicalLengthM: 2,
        depthM: 8,
        depthBandM: 5,
        сложение: 'округлое',
        пасть: 'хрящевая',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 4, опт: 16, макс: 24 },
        течение: 'слабое',
        держится: ['яма', 'бровка', 'твёрдое_дно'],
        стая: 'малая_стая',
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'резка', вес: 1 },
            { чем: 'икра', вес: 0.8 },
            { чем: 'рачок', вес: 0.8 },
            { чем: 'ракушка', вес: 0.6 },
            { чем: 'червь', вес: 0.4 },
        ],
        краснокнижная: true,
    },
];
//# sourceMappingURL=acipenserids.js.map